import React, { ReactNode, useCallback, useContext, useMemo } from 'react';

import { Popover, Divider } from 'antd';
import CustomTag from '@components/CustomTag';
import SessionContext from '@providers/Session/SessionContext';

interface IDataContent {
  title: string;
  value: string;
  show: boolean;
  color?: string;
}

interface ICustomPopover {
  title: string;
  titleValue: string;
  titleContent?: string;
  dataContent: IDataContent[];
  children: ReactNode;
}

const CustomPopover = ({
  title,
  titleValue,
  titleContent,
  dataContent,
  children,
  ...rest
}: ICustomPopover) => {
  const { theme } = useContext(SessionContext);

  const customTag = useCallback(
    (titleTag: any, value: any) => (
      <div style={{ margin: 4 }}>
        <span style={{ color: theme?.colors?.text }}>{`${titleTag}:`}</span>
        <CustomTag
          style={{
            marginLeft: 8,
            fontSize: '1rem',
            fontWeight: 'bold',
            opacity: '0.9',
          }}
        >
          {value}
        </CustomTag>
      </div>
    ),
    [theme?.colors?.text],
  );

  const customTitle = useMemo(
    () => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 4,
        }}
      >
        <span style={{ color: theme?.colors?.text }}>{`${title}:`}</span>
        {titleValue && (
          <CustomTag style={{ marginLeft: 6 }}>{titleValue}</CustomTag>
        )}
      </div>
    ),
    [theme?.colors?.text, title, titleValue],
  );

  const customContent = useMemo(
    () => (
      <div>
        <div>
          {titleContent && (
            <Divider
              style={{
                opacity: '0.4',
                fontSize: '0.9rem',
                margin: 0,
                marginBottom: 8,
              }}
            >
              {titleContent.toUpperCase()}
            </Divider>
          )}
        </div>
        {dataContent?.map(
          // @ts-ignore
          ({ title: tagTitle, value, show }) =>
            show && customTag(tagTitle, value),
        )}
      </div>
    ),
    [dataContent, customTag, titleContent],
  );

  return (
    <Popover title={customTitle} content={customContent} {...rest}>
      {children}
    </Popover>
  );
};

export default CustomPopover;
